<!-- 合同审批-->
<template>
  <div class="wrapper">
    <div class="navCard">
      <a
        v-for="(item, index) in tabs"
        :key="index"
        :class="[activeTab == index ? 'active' : '']"
        @click="changeTab(index)"
        >{{ item.title }}<span v-if="activeTab == index"></span
      ></a>
    </div>
    <div class="mainCard">
      <div class="mainBox">
        <div class="card">
          <div class="cardTitle">
            <h3>基本信息</h3>
            <span>{{
              myDataObj.approStatus | itemFilter('approve_status', allSelect)
            }}</span>
          </div>
          <p>
            <label>审核类型</label>
            <span>{{ myDataObj.groupName }}</span>
          </p>
          <p>
            <label>发起人</label>
            <span>{{ myDataObj.promoterName }}</span>
          </p>
          <p>
            <label>发起时间</label>
            <span>{{ myDataObj.promoterTime }}</span>
          </p>
          <p>
            <label>审批时长</label>
            <span>{{ myDataObj.diff | timeFilter }}</span>
          </p>
        </div>
        <div class="card">
          <div class="cardTitle">
            <h3>审批内容</h3>
          </div>
          <div class="cardMain" v-if="myDataObj.bizFlag == 'ZJZHINAJ'">
            <p>
              <label>调整前违约金</label>
              <span>{{ businessData.latefeeFact | kzmjTotalFilter }}</span>
            </p>
            <p>
              <label>调整后违约金</label>
              <span>{{
                businessData.lateFeeFactAmount | kzmjTotalFilter
              }}</span>
            </p>
            <p>
              <label>调整后需收</label>
              <span>{{
                (Number(businessData.lateFeeFactAmount || 0) +
                  Number(businessData.changeRequiredAmount))
                  | kzmjTotalFilter
              }}</span>
            </p>
          </div>
          <div class="cardMain" v-if="myDataObj.bizFlag == 'ZDJETZ'">
            <p>
              <label>调整日期</label>
              <span>{{ businessData.changeTime }}</span>
            </p>
            <p>
              <label>调整金额</label>
              <span>{{ businessData.subAmount | kzmjTotalFilter }}</span>
            </p>
            <p>
              <label>调整原因</label>
              <span>{{
                businessData.reason | itemFilter('change_reason', allSelect)
              }}</span>
            </p>
          </div>
          <div class="cardMain" v-if="myDataObj.bizFlag == 'ZDJETK'">
            <p>
              <label>应退日期</label>
              <span>{{ businessData.latestPayDate }}</span>
            </p>
            <p>
              <label>退款金额</label>
              <span>{{ businessData.toRefundedAmount | kzmjTotalFilter }}</span>
            </p>
            <p>
              <label>退款原因</label>
              <span>{{ businessData.remark }}</span>
            </p>
          </div>
          <div class="cardMain" v-if="myDataObj.bizFlag == 'ZDJETK'">
            <p>
              <label>同时调整应收</label>
              <span>{{ businessData.changePlanAmountFlag ? '是' : '否' }}</span>
            </p>
            <p>
              <label>同时结清</label>
              <span>{{ businessData.hasFinReceiptPayment ? '是' : '否' }}</span>
            </p>
          </div>
        </div>
        <div class="card">
          <div class="cardTitle">
            <h3>账单信息</h3>
            <!-- <a>查看佣金协议<img src="@/assets/img/titleRight.png" alt=""></a> -->
          </div>
          <div class="cardMain">
            <p>
              <label>租客</label>
              <span>{{ businessData.payerName }}</span>
            </p>
            <p>
              <label>合同号</label>
              <span>{{ businessData.contCode || '合同号为空' }}</span>
            </p>
            <p>
              <label>费项</label>
              <span>{{ businessData.feeCodeName }}</span>
            </p>
            <p>
              <label>账单编号</label>
              <span>{{ businessData.billCode }}</span>
            </p>
            <p>
              <label>收费期间</label>
              <span
                >{{ businessData.startDate }} - {{ businessData.endDate }}</span
              >
            </p>
          </div>
        </div>

        <!--审批附件  gdx-->
        <div class="card" v-if="approveFileArr.length > 0">
          <div class="cardTitle">
            <h3>审批附件</h3>
          </div>
          <div class="appendixCard" v-if="sence == 1">
            <div
              v-for="item in approveFileArr"
              @click="showFilepage(item)"
              :key="item.id"
            >
              <span class="approveFileBox">{{ item.displayName }}</span>
              <span
                >查看附件<img src="@/assets/img/rightIcon.png" alt=""
              /></span>
            </div>
          </div>
          <div class="appendixCard" v-else>
            <a :href="item.path" v-for="item in approveFileArr" :key="item.id">
              <span class="approveFileBox">{{ item.displayName }}</span>
              <span
                >查看附件<img src="@/assets/img/rightIcon.png" alt=""
              /></span>
            </a>
          </div>
        </div>
        <approvalProgress :myDataObj="myDataObj"></approvalProgress>
      </div>
    </div>
    <footer v-if="edit">
      <a @click="showShadow = 2">不通过</a>
      <a @click="showShadow = 1">审批通过</a>
    </footer>
    <div v-if="showShadow" class="shadowCard">
      <div class="shadowBox">
        <h3>审批原因</h3>
        <textarea placeholder="请输入说明信息" v-model="markContent"></textarea>
        <div class="btnCard">
          <a @click="showShadow = false">取消</a>
          <a @click="doInstance(showShadow)">确认</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from './approvalMixin' // 引入mixin文件
import BScroll from 'better-scroll'
import { number_format } from '@/utils/common'
import { loadOneInnstance } from '@/utils/api'

export default {
  name: 'App',
  mixins: [mixin],
  created() {
    this.getApproveFileFn()
  },
  methods: {
    loadOneInnstance() {
      let timestamp = new Date().getTime()
      loadOneInnstance({
        userId: this.userInfo.userInfo.id,
        companyId: this.companyId,
        timestamp: timestamp,
        platform: 'SAAS',
        sign: this.$md5(
          'mhxzkhl990' +
            'SAAS' +
            (timestamp + Number(this.companyId)) +
            'ncbbsss123'
        ),
        instanceId: this.$route.query.id
      }).then(res => {
        this.myDataObj = res.data
        this.$nextTick(function() {
          let mainCard = document.querySelector('.mainCard')
          this.scroll = new BScroll(mainCard, {
            scrollY: true,
            click: true
          })
        })
        for (let i = 0; i < res.data.taskList.length; i++)
          if (
            res.data.taskList[i].nodeType != 1 &&
            res.data.taskList[i].nodeType != 4 &&
            res.data.currentNodeId == res.data.taskList[i].nodeId &&
            res.data.subRound == res.data.taskList[i].subRound &&
            !res.data.taskList[i].itemPassMethod &&
            res.data.taskList[i].receiverId == this.userInfo.userInfo.id &&
            (res.data.approStatus == 1000 || res.data.approStatus == 3000)
          ) {
            this.edit = true
            return
          }
      })
    }
  },
  filters: {
    kzmjTotalFilter: function(value) {
      return number_format(value)
    }
  }
}
</script>

<style lang="less" scoped>
.wrapper {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 100vh;

  header {
    height: 88px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 34px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.8);
    line-height: 48px;

    img {
      width: 44px;
      height: 44px;
      position: absolute;
      left: 28px;
    }
  }

  .navCard {
    height: 88px;
    display: flex;

    a {
      flex: 1;
      height: 88px;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.6);
      line-height: 88px;
      text-align: center;
      position: relative;
    }

    .active {
      color: rgba(61, 96, 223, 1);
    }

    span {
      display: block;
      width: 40px;
      height: 6px;
      background: linear-gradient(
        270deg,
        rgba(79, 132, 255, 1) 0%,
        rgba(76, 90, 255, 1) 100%
      );
      border-radius: 4px 4px 0 0;
      position: absolute;
      bottom: 0;
      left: 106px;
    }
  }

  .mainCard {
    flex: 1;
    overflow: hidden;

    .mainBox {
      background: rgba(247, 248, 249, 1);
      padding: 20px;

      .card {
        background: rgba(255, 255, 255, 1);
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.02);
        border-radius: 16px;
        padding-bottom: 30px;
        margin-bottom: 20px;

        .cardTitle {
          height: 88px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 30px;
          box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.09);

          h3 {
            font-size: 28px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.8);
            line-height: 40px;
          }

          span {
            width: 104px;
            height: 44px;
            background: rgba(255, 246, 238, 1);
            border-radius: 22px;
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(255, 173, 93, 1);
            line-height: 44px;
            text-align: center;
          }

          a {
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.4);
            line-height: 40px;
            display: flex;

            img {
              width: 40px;
              height: 40px;
            }
          }
        }

        p {
          display: flex;
          margin-top: 30px;
          padding: 0 30px;

          label {
            width: 120px;
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.4);
            line-height: 34px;
            margin-right: 30px;
          }

          span {
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.8);
            line-height: 34px;
          }

          i {
            width: 40px;
            height: 40px;
            border-radius: 8px;
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            line-height: 40px;
            text-align: center;
            margin-right: 10px;
          }

          .zu {
            background: rgba(0, 0, 0, 0.02);
            border: 2px solid rgba(0, 0, 0, 0.15);
            color: rgba(0, 0, 0, 0.6);
          }

          .wu {
            opacity: 0.2;
            border: 2px solid;
            border-image: linear-gradient(
                270deg,
                rgba(79, 132, 255, 1),
                rgba(76, 90, 255, 1)
              )
              2 2;
            color: rgba(61, 96, 223, 1);
          }

          .bu {
            background: rgba(22, 188, 132, 0.1);
            border: 2px solid rgba(22, 188, 132, 0.2);
            color: rgba(22, 188, 132, 1);
          }
        }

        .box {
          display: flex;

          p {
            flex: 1;
          }
        }

        .dateCard {
          width: 670px;
          height: 120px;
          background: rgba(247, 248, 249, 1);
          border-radius: 16px;
          margin: 30px 20px 0;
          display: flex;

          .dateBox {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            label {
              font-size: 24px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.4);
              line-height: 34px;
              margin-bottom: 6px;
            }

            span {
              font-size: 24px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.8);
              line-height: 34px;
              margin-top: 6px;
            }
          }
        }

        .houseCard {
          padding: 20px;

          .houseTitle {
            width: 670px;
            height: 60px;
            background: rgba(248, 248, 248, 1);
            border-radius: 16px 0 0 16px;
            display: flex;
            align-items: center;

            span {
              font-size: 20px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.6);
              line-height: 28px;
              padding-left: 20px;
            }
          }

          .houseBox {
            p {
              display: flex;
              height: 100px;
              align-items: center;
              margin: 0;
              padding: 0;

              span {
                font-size: 24px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
                line-height: 34px;
                padding-left: 20px;
              }
            }
          }

          .buildName {
            width: 256px;
          }

          .floorName {
            width: 122px;
          }

          .houseCode {
            width: 158px;
          }

          .area {
            width: 114px;
          }
        }

        .deductFromCard {
          width: 670px;
          padding: 20px;

          .deductFromTitle {
            height: 60px;
            background: rgba(248, 248, 248, 1);
            border-radius: 16px 0 0 16px;
            display: flex;
            align-items: center;

            span {
              font-size: 20px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.6);
              line-height: 28px;
              padding-left: 20px;
            }
          }

          .houseBox {
            p {
              display: flex;
              height: 100px;
              align-items: center;
              margin: 0;
              padding: 0;

              span {
                font-size: 24px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
                line-height: 34px;
                padding-left: 20px;
              }
            }
          }

          .offsetFeeCode {
            width: 120px;
          }

          .surplusMoney {
            width: 114px;
          }

          .houseCode {
            width: 158px;
          }

          .area {
            width: 114px;
          }
        }

        .changeCard {
          .changeTitle {
            display: flex;
            margin-top: 30px;
            margin-left: 30px;

            a {
              width: 114px;
              height: 44px;
              border-radius: 8px;
              font-size: 24px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(102, 102, 102, 1);
              line-height: 44px;
              text-align: center;
              background: rgba(0, 0, 0, 0.04);
            }

            .activeChangeTitle {
              background: linear-gradient(
                270deg,
                rgba(79, 132, 255, 1) 0%,
                rgba(76, 90, 255, 1) 100%
              );
              color: rgba(255, 255, 255, 1);
            }
          }
        }

        .cancel {
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.8);
          line-height: 34px;
        }

        .totalCostCard {
          padding: 20px;

          .totalCostTitle {
            width: 670px;
            height: 60px;
            background: rgba(248, 248, 248, 1);
            border-radius: 16px 0 0 16px;
            display: flex;
            align-items: center;

            span {
              font-size: 20px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.6);
              line-height: 28px;
              padding-left: 20px;
            }
          }

          .type {
            width: 290px;
          }

          .should {
            width: 228px;
          }

          .account {
            width: 142px;
          }

          .totalCostBox {
            p {
              display: flex;
              height: 100px;
              align-items: center;
              margin: 0;
              padding: 0;

              span {
                font-size: 24px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
                line-height: 34px;
                padding-left: 20px;
              }
            }
          }

          .sumCard {
            height: 40px;
            box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.09);
            display: flex;
            align-items: center;
            justify-content: flex-end;
            padding-top: 24px;

            h4 {
              font-size: 24px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.8);
              line-height: 34px;
            }

            span {
              font-size: 28px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: rgba(0, 0, 0, 0.8);
              line-height: 40px;
            }
          }
        }

        .terminateReasons {
          padding: 30px;
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.8);
          line-height: 34px;
        }
      }
    }
  }

  footer {
    height: 112px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 -2px 6px 0 rgba(0, 0, 0, 0.08);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 60px;

    a {
      &:first-child {
        width: 296px;
        height: 72px;
        border-radius: 40px;
        border: 1px solid rgba(61, 96, 223, 1);
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(61, 96, 223, 1);
        line-height: 72px;
        text-align: center;
      }

      &:last-child {
        width: 296px;
        height: 72px;
        background: linear-gradient(
          270deg,
          rgba(79, 132, 255, 1) 0%,
          rgba(76, 90, 255, 1) 100%
        );
        border-radius: 40px;
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        line-height: 72px;
        text-align: center;
      }
    }
  }

  .shadowCard {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;

    .shadowBox {
      width: 540px;
      height: 360px;
      background: rgba(255, 255, 255, 1);
      border-radius: 16px;

      h3 {
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.8);
        line-height: 44px;
        margin: 40px 0;
        text-align: center;
      }

      textarea {
        width: 474px;
        height: 100px;
        background: rgba(0, 0, 0, 0.04);
        border-radius: 4px;
        margin-left: 32px;
        padding: 10px;
        box-sizing: border-box;
      }

      .btnCard {
        width: 540px;
        height: 96px;
        background: rgba(245, 245, 245, 1);
        border-radius: 0px 0px 16px 16px;
        margin-top: 40px;
        display: flex;

        a {
          flex: 1;
          font-size: 32px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.8);
          line-height: 96px;
          text-align: center;
        }
      }
    }
  }
}
</style>
